import React from 'react';
import { InspectorSignatureCanvas } from './InspectorSignatureCanvas';
import { InspectorSignatureImage } from './InspectorSignatureImage';

export const InspectorSignature = ({ signatureType, edit, ...props }) =>
  edit ? <InspectorSignatureCanvas signatureType={signatureType} {...props} /> : <InspectorSignatureImage {...props} />;
